import { render, staticRenderFns } from "./editDriver.vue?vue&type=template&id=bcdc0b12&scoped=true&"
import script from "./editDriver.vue?vue&type=script&lang=js&"
export * from "./editDriver.vue?vue&type=script&lang=js&"
import style0 from "./editDriver.vue?vue&type=style&index=0&id=bcdc0b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdc0b12",
  null
  
)

export default component.exports